import React, {Component} from 'react'
import {List, Modal, Button, message, Input, Rate, Tooltip} from 'antd';
import moment from 'moment'
import {connect} from 'react-redux';
import icon_download from '../img/icon_download.png'
import {Link} from 'react-router-dom';


class DownloadListItem extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isModalOpen: false,
            openIsDownOrderListFlag: false,
            downloadVisible: false,
        }
    }

    componentDidMount() {
        const {downLoadOrderFilesList,} = this.props.item
        this._downloadVisible(downLoadOrderFilesList)
    }

    handleCancel = () => {
        this.setState({
            isModalOpen: false
        })
    }


    downloadMainOrder = () => {
        this.openClient(this.props.item.downLoadOrderFilesList);
        this.setState({openIsDownOrderListFlag: false})
    }

    _downloadVisible = (dataList = []) => {
        // console.log('下载列表:', dataList);
        // dataList = dataList ? dataList : [];
        for (const order of dataList) {
            if (order.exam !== 'approve') {
                this.setState({downloadVisible: false});
                return
            }
        }
        this.setState({downloadVisible: true})
    }

    render() {
        const {
            resourceType,
            orderId,
            orderCreationTime,
            downLoadOrderFilesList,
            orderStatus,
            statusDescribe
        } = this.props.item
        return (
            <div className='order-produce-list-main'>
                <div className='order-produce-list-item'>
                    <div className='order-produce-list-item-unit'>
                        <span className='order-download-list-item-title'><Link to={{
                            pathname: '/DownloadListItemDetail',
                            state: {orderId, downLoadOrderFilesList}
                        }}>{orderId}</Link></span>
                        <div className='order-download-list-item-function'>
                            <span className='order-produce-list-item-detail'
                                  onClick={() => this.setState({isModalOpen: true})}>详情</span>
                            <Tooltip title={!this.state.downloadVisible ? '存在子订单未通过审核' : ''}>
                                <Button size='small' className='download-order-list-item-button' type="primary"
                                        disabled={!this.state.downloadVisible}
                                        icon={<img src={icon_download}></img>}
                                        onClick={() => this.setState({openIsDownOrderListFlag: true})}>下载</Button>
                            </Tooltip>
                        </div>
                    </div>
                    <div className='order-produce-list-item-split'/>
                    <div className='order-produce-list-item-unit'>
                        <div>
                            <span
                                className='order-produce-list-item-text2'>下单时间：{moment(orderCreationTime).format("yyyy-MM-DD HH:mm:ss")}</span>
                        </div>
                        <span
                            className='order-produce-list-item-text2'>共{downLoadOrderFilesList ? downLoadOrderFilesList.length : 0}子订单</span>
                    </div>
                </div>
                <Modal
                    title={orderId}
                    visible={this.state.isModalOpen}
                    onCancel={this.handleCancel}
                    footer={false}
                    className='order-download-modal'
                >
                    <p className='order-download-modal-span'>订单编号：{orderId}</p>
                    <p className='order-download-modal-span'>创建时间：{moment(orderCreationTime).format("yyyy-MM-DD HH-mm-ss")}</p>
                    <p className='order-download-modal-span'>处理状态：{orderStatus}</p>
                    <p className='order-download-modal-span'>描述状态：{statusDescribe}</p>
                </Modal>
                <Modal visible={this.state.openIsDownOrderListFlag} onOk={() => this.downloadMainOrder()}
                       onCancel={() => this.setState({openIsDownOrderListFlag: false})}>
                    <div className='MyOrder_DLOrderModalContent'>
                        <div className='MyOrder_DLOrderModalText'>订单号：{orderId}</div>
                        <div
                            className='MyOrder_DLOrderModalText'>该订单下子订单数为{downLoadOrderFilesList && downLoadOrderFilesList.length}条，确定下载所有子订单吗？
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }

    openClient = (data) => {
        //通过这个循环保证修改每个订单的下载状态
        console.log('openClient', data)
        let flag = true;
        data.map((item) => {
            if (!item.orderDownloadAddr) {
                flag = false;
            } else
                item.orderDownloadAddr = item.orderDownloadAddr.replace("http://10.0.121.14:8084", "https://caplos.aircas.ac.cn/zdTiles")
        })
        if (!flag) {
            message.error("下载订单内含有没有文件地址的订单，请确认订单完成后重试！");
            return;
        }
        // return;
        let _this = this;
        const linkTmp = document.createElement('a');
        linkTmp.href = 'ydspacebasedbee://';

        linkTmp.onclick = function (e) {
            _this.callapp_openClient({
                data: data,
                callbackTrue: function (dataT) {
                    message.success("准备打开客户端，正在预备下载！");
                    _this.createWSForSimple(data);
                },
                callbackFlase: function () {
                    message.info("检测到本机未安装客户端，请先安装客户端后再下载订单！");
                    const link = document.createElement('a');
                    link.href = 'https://caplos.aircas.ac.cn/oss/group1/M00/1D/FE/rBIAB2bs0R2AVIbLFLridyNmEaw852.exe';
                    link.download = '';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    console.log("客户端打开失败！");
                }
            });
        }
        linkTmp.click();
    }

    //确认客户端是否被打开的回调函数（感觉有点离谱，但是暂时确实想不到更好的办法，好像百度网盘也是类似的逻辑）
    callapp_openClient({data, callbackTrue, callbackFlase}) {
        var t = setTimeout(callbackFlase, 1000);
        var inp = document.createElement("input");
        inp.style.position = "absolute";
        inp.style.clip = "rect(0, 0, 0, 0)";
        // 出现下载框的时候往下跳的问题
        inp.style.top = '0'
        inp.style.left = '0'

        // inp.style.display="none";
        function blur() {
            window.clearTimeout(t);
            callbackTrue(data);
        }

        inp.addEventListener("blur", blur); // 监听blur事件
        document.body.appendChild(inp);
        inp.focus(); // 获取焦点
        setTimeout(function () { // 删除无用的标签
            inp.removeEventListener("blur", blur);
            document.body.removeChild(inp);
        }, 1000);
        //有客户端 如果有本地exe应用，就会弹框，input失去焦点，然后执行blur()事件 清空t定时器 - 删除无用的标签定时器
        //无客户端 不会弹框，input也不会失去焦点 触发t定时器- 执行callback - 删除无用的标签定时器
    }

    createWSForSimple = (data) => {
        let _this = this;
        this.webSocketClient = new WebSocket('ws://127.0.0.1:9312');// 新建一个WebSocket通信，连接一个本地服务器
        this.webSocketClient.onopen = function (e) {             //连接建立时触发函数
            console.log('网站ws通讯已创建，目前状态为：' + _this.webSocketClient.readyState);
            clearInterval(_this.wsTimer);
            _this.setState({wsToClientTimerFlag: true});
            if (_this.webSocketClient.readyState === 1) {
                _this.wsSendMessage(JSON.stringify({
                    type: 'transferToken',
                    data: {token: _this.props.user.token, username: _this.props.user.username}
                }));
                _this.wsSendMessage(JSON.stringify({type: 'download', data: data}));       //传送消息
            }
        }
        this.webSocketClient.onmessage = function (evt) {       //客户端接收服务端数据时触发
            console.log("网站接收到了来自客户端的消息：", evt);//向页面追加显示服务端发送给客户端的消息
        }
        this.webSocketClient.onclose = function (evt) {          //连接关闭时触发
            console.log("网站的连接通关已关闭!", evt);
            if (_this.state.wsToClientTimerFlag) {
                let nowTimer = 0;
                let timeCount = 500;
                let maxTimer = 15000;
                _this.wsTimer = setInterval(() => {
                    _this.createWSForSimple(data);
                    nowTimer += timeCount;
                    console.log("网站尝试连接客户端中，重试：", nowTimer / timeCount);
                    if (nowTimer >= maxTimer) {
                        clearInterval(_this.wsTimer);
                        console.log("网站尝试连接客户端重试结束……");
                    }
                }, timeCount);
                _this.setState({wsToClientTimerFlag: false});
            }
        };

    }

    wsSendMessage = (mes) => {   //向服务端发送消息
        console.log("wsSendMessage", mes);
        this.webSocketClient.send(mes);       //传送消息
    }
}

const mapState = (state) => ({ //返回值  对应的是  组件的props  
    user: state.userReducer.get('user').toJS(), zd_user: state.userReducer.get('zd_user').toJS(),
})
const mapDispatch = (dispatch, ownProps) => ({})

export default connect(mapState, mapDispatch)(DownloadListItem);
